import { Description, Label, Radio, RadioGroup } from '@heroui/react';
import type { UsageType } from '../../api/my-parking-spots';

interface UsageTypeRadioGroupProps {
  label: string;
  description?: string;
  borrowLabel?: string;
  rentLabel?: string;
  value: UsageType;
  onChange: (value: UsageType) => void;
  isDisabled?: boolean;
  orientation?: 'horizontal' | 'vertical';
  allowedTypes?: UsageType[];
}

export function UsageTypeRadioGroup({
  label,
  description,
  borrowLabel = 'Empréstimo',
  rentLabel = 'Aluguel',
  value,
  onChange,
  isDisabled = false,
  orientation = 'horizontal',
  allowedTypes = ['BORROW', 'RENT'],
}: UsageTypeRadioGroupProps) {
  const showBorrow = allowedTypes.includes('BORROW');
  const showRent = allowedTypes.includes('RENT');

  return (
    <section className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <Label className="text-base font-semibold">{label}</Label>
        {description ? <Description>{description}</Description> : null}
      </div>
      <RadioGroup
        variant="secondary"
        orientation={orientation}
        className="gap-4 [&_[data-slot=radio]]:mt-0"
        aria-label={label}
        value={value}
        onChange={(next) => onChange(next as UsageType)}
        isDisabled={isDisabled}
      >
        {showBorrow ? (
          <Radio value="BORROW">
            <Radio.Content>
              <Radio.Control>
                <Radio.Indicator />
              </Radio.Control>
              {borrowLabel}
            </Radio.Content>
          </Radio>
        ) : null}
        {showRent ? (
          <Radio value="RENT">
            <Radio.Content>
              <Radio.Control>
                <Radio.Indicator />
              </Radio.Control>
              {rentLabel}
            </Radio.Content>
          </Radio>
        ) : null}
      </RadioGroup>
    </section>
  );
}
